import * as d3 from "d3";
import { drawConnectionLines } from "@/components/VivoPlots/functions/utils/drawConnectionLines";
import { calculateSwarmplotPosition } from "@/components/VivoPlots/functions/drawPlotData/utils/calculateSwarmplotPosition";
import { getNormalizedSelectedId } from "@/components/VivoPlots/functions/utils/selectedIdUtils";
import { drawCircles } from "./utils/drawCircles";

export async function drawSwarmPlot(
  plotClassName: string,
  data: unknown,
  scales: any[],
  plotConfig: unknown,
) {
  const normalizedId = getNormalizedSelectedId(plotConfig as any);

  // Flatten the data for processing
  const swarmData = await calculateSwarmplotPosition(data, scales);

  const svg = d3.select(`svg.${plotClassName}`);

  //create swarm container
  const swarmContainer = svg
    .selectAll("g.swarm")
    .data(swarmData, (d: any) => `${d.category}|${d.subgroup}`)
    .join("g")
    .classed("swarm", true);

  //add circles
  const fillScale = scales?.find((scale: any) => scale?.type === "fill");

  drawCircles(
    swarmContainer as unknown as d3.Selection<
      d3.BaseType,
      { points: any[] },
      d3.BaseType,
      unknown
    >,
    normalizedId,
    plotConfig as any,
    plotClassName,
    fillScale,
  );

  drawConnectionLines(plotClassName);
}
